// /* eslint-disable import/no-extraneous-dependencies */
import { autoBatchEnhancer, configureStore } from '@reduxjs/toolkit';

import headerReducer from 'redux/reducers/headerReducer';
import notificationReducer from 'redux/reducers/notificationReducer';
import experiment from 'redux/reducers/experimentReducer';
import layerReducer from 'redux/reducers/layerReducer';
import systemTaskReducer from './reducers/systemTaskReducer';
import experimentDataReducer from './reducers/experimentDataReducer';
import ingredientDetailReducer from './reducers/ingredientDetailReducer';
import ingredientTableReducer from './reducers/ingredientTableReducer';
import CryoprotectantReducer from './reducers/cryoprotectantReducer';
import SoakingReducer from './reducers/soakingReducer';
import synchrotronTripReducer from './reducers/synchrotronTripReducer';
import puckReducer from './reducers/puckReducer';
import dewarReducer from './reducers/dewarReducer';
import commonReducer from './reducers/commonReducer';
import setupReducer from './reducers/setupReducer';
import settingsTabReducer from './reducers/settingsTabReducer';
import imagingSchedulesReducer from './reducers/imagingSchedulesReducer';
import imagingSettingsReducer from './reducers/imagingSettingsReducer';
import imageManagementTaskReducer from './reducers/imageManagementTaskReducer';
import searchnFilterReducer from './reducers/searchnFilterReducer';
import wellReducer from './reducers/wellReducer';
import GeneralDispensingPropertiesReducer from './reducers/GeneralDispensingPropertiesReducer';
import imagerQuotaReducer from './reducers/imagerQuotaReducer';
import backgroundJobsReducer from './reducers/backgroundJobsReducer';
import archivingReducer from './reducers/archivingReducer';
import unarchivingReducer from './reducers/unarchivingReducer';

const store = configureStore({
  reducer: {
    plate: experiment,
    backgroundJobs: backgroundJobsReducer,
    headers: headerReducer,
    notification: notificationReducer,
    layer: layerReducer,
    systemTasks: systemTaskReducer,
    experiment: experimentDataReducer,
    ingredientDetail: ingredientDetailReducer,
    ingredientsTable: ingredientTableReducer,
    cryoprotectants: CryoprotectantReducer,
    soakings: SoakingReducer,
    synchrotronTrip: synchrotronTripReducer,
    pucks: puckReducer,
    dewars: dewarReducer,
    common: commonReducer,
    setupTab: setupReducer,
    settingsTab: settingsTabReducer,
    imagingSchedules: imagingSchedulesReducer,
    imagingSettings: imagingSettingsReducer,
    imageManagementTask: imageManagementTaskReducer,
    imagerQuota: imagerQuotaReducer,
    searchnFilter: searchnFilterReducer,
    well: wellReducer,
    generalDispensingProperties: GeneralDispensingPropertiesReducer,
    archiving: archivingReducer,
    unarchiving: unarchivingReducer,
  },
  enhancers: (existingEnhancers) => {
    return existingEnhancers.concat(autoBatchEnhancer());
  },
  middleware: (getDefaultMiddleware) =>
    process.env.NODE_ENV === 'development'
      ? getDefaultMiddleware() //.concat(logger)
      : getDefaultMiddleware(),
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;

export default store;
